module.exports = __webpack_public_path__ + "img/logo-dark.d45df013.svg";